import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import award1 from '../../../assets/award/award1.webp'
import award2 from '../../../assets/award/award2.webp'
import award3 from '../../../assets/award/award3.webp'
import award4 from '../../../assets/award/award4.webp'
import award5 from '../../../assets/award/award5.webp'
import award6 from '../../../assets/award/award6.webp'
import award7 from '../../../assets/award/award7.webp'
import award8 from '../../../assets/award/award8.webp'
import award9 from '../../../assets/award/award9.webp'
import award10 from '../../../assets/award/award10.webp'
import award11 from '../../../assets/award/award11.webp'
import award12 from '../../../assets/award/award12.jpeg'
import award13 from '../../../assets/award/award13.jpeg'
import award14 from '../../../assets/award/award14.jpeg'
import './Award.css'

const AwardImages = () => {
  return (
    <div>
      {' '}
      <h2 className="awardH">
        Our Path to Distinction: Recognitions & Achievements
      </h2>
      <p className='awardP'>
        At Sharva Clinic, excellence is not merely a goal; it is our standard.
        Throughout the years, our commitment to advanced cosmo-aesthetic
        treatments, patient contentment, and innovation has garnered us esteemed
        awards and accolades. Every award demonstrates our steadfast dedication
        to providing safe, effective, and transformative therapies. These
        accomplishments reflect the confidence our patients have in us and the
        proficiency of our highly trained staff. As we strive to expand the
        limits of aesthetic progress, we stay dedicated to delivering
        exceptional care that boosts confidence and promotes well-being.
      </p>
      <div className="awardImg">
        <Container>
          <Row>
            <Col md={3}>
              <a href="https://www.hindustantimes.com/lifestyle/health/avoid-these-diwali-health-hazards-essential-tips-to-protect-your-skin-hair-this-festive-season-101730203393273.html">
                <img
                  src={award1}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.healthshots.com/beauty/skin-care/winter-routine-for-sensitive-skin/">
                <img
                  src={award2}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.hindustantimes.com/lifestyle/health/festive-glow-goals-transform-your-skin-with-these-pre-diwali-beauty-treatments-101729507581846.html">
                <img
                  src={award3}
                  alt="award and recognition"
                  className="award2"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.timesnownews.com/lifestyle/beauty/skincare-makeup/winter-skincare-and-haircare-with-changing-weather-experts-recommend-modifying-your-routine-article-114495364">
                <img
                  src={award4}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.onlymyhealth.com/surgical-and-nonsurgical-options-to-manage-facial-scars-from-doctor-in-hindi-12977821370">
                <img
                  src={award5}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.hindustantimes.com/lifestyle/health/struggling-with-hair-fall-in-winter-heres-why-it-happens-and-haircare-tips-to-stop-it-101734160663522.html">
                <img
                  src={award6}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://indianexpress.com/article/lifestyle/life-style/yearender-2024-neetu-kapoor-bryan-johnson-healthy-ageing-was-on-everyone-mind-this-year-9724480/">
                <img
                  src={award7}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.healthshots.com/how-to/ways-to-remove-pigmentation-from-face/">
                <img
                  src={award8}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.onlymyhealth.com/how-to-take-care-of-face-after-laser-treatment-in-hindi-12977823568">
                <img
                  src={award9}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.timesnownews.com/lifestyle/beauty/from-am-to-pm-experts-dish-on-what-makes-the-perfect-skincare-routine-article-117557252">
                <img
                  src={award10}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.hindustantimes.com/lifestyle/health/retinol-vs-ravinage-is-the-hype-worth-it-or-is-retinol-still-king-in-anti-ageing-skincare-battle-101738243966209.html">
                <img
                  src={award11}
                  alt="award and recognition"
                  className="award1"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.hindustantimes.com/lifestyle/health/are-dark-spots-making-you-look-older-here-s-how-to-reverse-hyperpigmentation-101741161925614.html">
                <img
                  src={award12}
                  alt="award and recognition"
                  className="award2"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.magzter.com/nb/stories/newspaper/The-Daily-Guardian/IS-YOUR-SUNSCREEN-SAFE-6-MYTHS-DEBUNKED-BY-EXPERT?srsltid=AfmBOorYFR3ZPUG5nSyOVo-GoXS0gjisLbx1k6_rKW1Ta45QHjeqWTTK">
                <img
                  src={award13}
                  alt="award and recognition"
                  className="award2"
                />
              </a>
            </Col>
            <Col md={3}>
              <a href="https://www.dailypioneer.com/2025/vivacity/the-truth-about-hair-transplants.html">
                <img
                  src={award14}
                  alt="award and recognition"
                  className="award2"
                />
              </a>
            </Col>
          </Row>
          <br />
          <br />
        </Container>
      </div>
    </div>
  )
}

export default AwardImages
